export default {
  dealers: [],
  current_dealers:''
}
